export default __webpack_public_path__ + "static/media/about-summer.55f9f079.png";